import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "components/common/Typograph/Typograph.Style";

export const SectionOrganizeContainer = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",

  paddingTop: "40px",
  margin: "0 auto",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
  },
}));

export const SectionOrganizeHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
}));

export const SectionOrganizeTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  fontWeight: "700",
  margin: 0,
}));

export const SectionOrganizeDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  margin: 0,
}));

export const SectionOrganizeImage = styled.div(() => ({
  display: "flex",
  justifyContent: "center",
}));
